@if (budgetId()) {
    @if (!isMobile) {
        <p-table 
            #dt
            [columns]="visibleColumns"
            [value]="invoices()"
            dataKey="invoiceId"
            [rowHover]="true"
            [rows]="100"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50, 100, 200]"
            [loading]="isLoading"
            [paginator]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [filterDelay]="500"
            [size]="'large'"
            stripedRows 
            sortField="invoiceId"
            selectionMode="single"    
            [globalFilterFields]='searchColumns'
            [dt]="tableDts"
            [scrollable]="true"
            scrollHeight="650px"
        >

            <ng-template #caption>
                <div class="d-flex">
                    @if (baService.isBaAdmin()) {
                        <p-button 
                            icon="pi pi-plus"
                            label="Create Invoice" 
                            (click)="createInvoice()" 
                            class="pr-1"
                        />
                    }

                    <p-multiselect 
                        class="pl-1"
                        display="chip" 
                        [options]="availableColumns" 
                        [(ngModel)]="visibleColumns" 
                        optionLabel="header" 
                        selectedItemsLabel="Show / Hide" 
                        [style]="{ 'min-width': '100px' }" 
                        placeholder="Choose Columns" 
                        (ngModelChange)='columnChange($event)'
                    />

                    <p-button 
                        class="pl-1"
                        (click)="opp.toggle($event)" 
                        icon="pi pi-search" 
                        label="Filters" 
                        severity="warn"
                    />
                    <p-popover #opp>
                        <div>
                            <label class='for'>Invoice Status</label>
                            <p-select 
                                [(ngModel)]="filters.baInvoiceStatus" 
                                [options]="filterInvoiceStatus" 
                                placeholder="Invoice Status" 
                                (onChange)="
                                    this.filters.baInvoiceStatus = $event.value; 
                                    getList($event.value);
                                " 
                                optionLabel="text" 
                                optionValue="value"
                                style="min-width: 14rem" 
                                [panelStyle]="{ minWidth: '16rem' }"
                            />
                            <br /><br />

                            <label class='for'>PO</label>
                            <p-select 
                                [(ngModel)]="filters.poId" 
                                [options]="filterBaPOs" 
                                placeholder="PO" 
                                (onChange)="
                                    this.filters.poId = $event.value; 
                                    getList($event.value);
                                " 
                                optionLabel="text" 
                                optionValue="value"
                                style="min-width: 14rem" 
                                [panelStyle]="{ minWidth: '16rem' }"
                            />
                        </div>
                    </p-popover>

                    <p-iconfield 
                        iconPosition="right" 
                        class="ml-auto"
                    >  
                        <p-button 
                            icon="pi pi-external-link" 
                            label="Export" 
                            (click)="exportList()" 
                            class="pr-1"
                        />
                        <p-inputicon>
                            <i class="pi pi-search pl-2"></i>
                        </p-inputicon>
                        <input 
                            #searchValue
                            pInputText 
                            type="text" 
                            (input)="dt.filterGlobal($event.target.value, 'contains')" 
                            placeholder="Search..." 
                        />
                        <p-button 
                            class="pl-1"
                            label="Clear" 
                            [outlined]="true" 
                            icon="pi pi-filter-slash" 
                            (click)="clearFilters(dt, searchValue)" 
                        />
                    </p-iconfield> 
                </div>
            </ng-template>

            <ng-template 
                #header 
                let-columns
            >
                <tr>
                    @for (col of columns; track col; let i = $index) {
                        <th 
                            [pSortableColumn]="col?.canSort ? $safeNavigationMigration(col?.field) : null" 
                            [class]="col?.cellClass"
                        >
                            @if (col?.headerTooltip != "") {
                                <span 
                                    container='body' 
                                    class="ignoreTooltipStyle" 
                                    [ngbTooltip]="$safeNavigationMigration(col?.headerTooltip)"
                                >
                                    {{ col?.header }}
                                </span>
                            } @else { {{ col?.header }} }
                            @if (col?.canSort) { <p-sortIcon [field]="$safeNavigationMigration(col?.field)" /> }
                        </th>
                    }
                </tr>
            </ng-template>

            <ng-template 
                #body 
                let-row
                let-columns="columns"
            >
                <tr 
                    [pSelectableRow]="row" 
                    (click)="editInvoice(row.invoiceId)"
                >
                    @for (col of columns; track col) {
                        <td [class]="col?.cellClass">
                            @if (columnDefs.get(colKey)?.isCurrency) { {{ row[col?.field] | currency }} } 
                            @else { {{ row[col?.field] }} }
                        </td>
                    }
                </tr>
            </ng-template>

            <ng-template #emptymessage>
                <tr>
                    <td 
                        colspan="10" 
                        class="text-center"
                    >No records found.</td>
                </tr>
            </ng-template>

        </p-table>
    } @else {
        <div class="d-flex mb-2 pl-3 pr-3">
            @if (baService.isBaAdmin()) {
                <p-button 
                    icon="pi pi-plus"
                    label="" 
                    (click)="createInvoice()" 
                />
            }

            <p-button 
                class="pl-1"
                (click)="opp.toggle($event)" 
                icon="pi pi-search" 
                label="" 
                severity="warn"
            />
            <p-popover #opp>
                <div>
                    <label class='for'>Invoice Status</label>
                    <p-select 
                        [(ngModel)]="filters.baInvoiceStatus" 
                        [options]="filterInvoiceStatus" 
                        placeholder="Invoice Status" 
                        (onChange)="
                            this.filters.baInvoiceStatus = $event.value; 
                            getList($event.value);
                        " 
                        optionLabel="text" 
                        optionValue="value"
                        style="min-width: 14rem" 
                        [panelStyle]="{ minWidth: '16rem' }"
                    />
                    <br /><br />

                    <label class='for'>PO</label>
                    <p-select 
                        [(ngModel)]="filters.poId" 
                        [options]="filterBaPOs" 
                        placeholder="PO" 
                        (onChange)="
                            this.filters.poId = $event.value; 
                            getList($event.value);
                        " 
                        optionLabel="text" 
                        optionValue="value"
                        style="min-width: 14rem" 
                        [panelStyle]="{ minWidth: '16rem' }"
                    />
                </div>
            </p-popover>
        </div>

        @if (invoices()?.length == 0) { <div class="text-center">No Records</div> }

        @for (row of invoices(); track row) {
            <div class="mb-4 flex items-center justify-center">
                <p-card class="p-card pl-3 pr-3">
                    <ng-template #header>
                        <div class="pb-2 p-card-header">
                        <h3 class="text-center">{{ row.invoiceNumber }}</h3>
                    </div>
                    </ng-template>

                    <ng-template #title>
                        <div class="text-left">Facility: {{ row.facilityName }}</div>
                    </ng-template>

                    <ng-template #subtitle>
                        <div class="text-left">Fiscal Year: {{ row.countyName }}</div>
                    </ng-template>

                    <div>
                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Effective Dt: </div>
                            <div class="col-md-6 text-right">{{ row.effectiveDate }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Request #</div>
                            <div class="col-md-6 text-right">{{ row.requestNumber }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Confirm #</div>
                            <div class="col-md-6 text-right">{{ row.confirmationNumber }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">PO #</div>
                            <div class="col-md-6 text-right">{{ row.poNumber }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Invoice $</div>
                            <div class="col-md-6 text-right">{{ row.invoicedAmt | currency }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Paid $</div>
                            <div class="col-md-6 text-right">{{ row.paidAmt | currency }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Paid CR #</div>
                            <div class="col-md-6 text-right">{{ row.paymentCrNum }}</div>
                        </div>

                        <div class="row pb-1">
                            <div class="col-md-6 text-left">Reconciled $</div>
                            <div class="col-md-6 text-right">{{ row.reconciledAmt | currency }}</div>
                        </div>
                    </div>

                    <ng-template #footer>
                        <div class="row">
                            <div class="col-md-6 text-left">
                                <p-button 
                                    icon="pi pi-external-link"
                                    label="Edit" 
                                    severity="info" 
                                    (click)="
                                        $event.stopPropagation(); 
                                        editInvoice(row.invoiceId);
                                    "
                                />
                            </div>
                            <div class="col-md-6 text-right"></div>
                        </div>
                    </ng-template>
                </p-card>
            </div>
        }
    }
}